import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AuthService } from 'src/app/services/auth.service';
import { CoachService } from 'src/app/services/coach.service';
import * as Global from 'src/app/global';
import { ToastrService } from 'ngx-toastr';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
})
export class SignupComponent implements OnInit {
  Global = Global;
  registerForm: FormGroup;
  registerSchoolForm: FormGroup;
  registerAthleticDirectorForm: FormGroup;


  otpSent: boolean = false;
  cityMaster: any[] = [];
  divisionMaster: any[] = [];
  drawMaster: any[] = [];
  levelMaster: any[] = [];
  ratingMaster: any[] = [];
  schoolMaster: any[] = [];
  sectionMaster: any[] = [];
  sportMaster: any[] = [];
  stateMaster: any[] = [];
  signupType: any;
  selectedTabIndex: any;
  queryParams: any = null;
  otp: any = null;
  emailToVerify: any = null;
  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private coachService: CoachService,
    private spinner: NgxSpinnerService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.queryParams = this.route.snapshot.queryParamMap.get('tab') || '';
    this.otp = this.route.snapshot.queryParamMap.get('otp') || '';

    this.registerForm = formBuilder.group({
      first_name: [null, Validators.compose([Validators.required])],
      last_name: [null, Validators.compose([Validators.required])],
      items: this.formBuilder.array([this.newRequest()], { validators: [this.duplicateSportLevelValidator()] }),   // ✅ FormArray created with FormBuilder

      email: [
        null,
        Validators.compose([Validators.required, Validators.email]),
      ],
      phone: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]*$'),
          Validators.minLength(10),
          Validators.maxLength(12),
        ]),
      ],
      school_name: [null, Validators.compose([Validators.required])],
      state_name: [null, Validators.compose([Validators.required])],
      city_name: [null, Validators.compose([Validators.required])],
      section_name: [null, Validators.compose([Validators.required])],
      zip_code: [null, Validators.compose([Validators.required])],
      division: [null, Validators.compose([Validators.required])],
      rating: [null, Validators.compose([Validators.required])],
      league: [null, Validators.compose([Validators.required])],
      password: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(20),
          Validators.pattern(
            '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*.,?]).+$'
          ),
        ]),
      ],
      password_confirmation: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(20),
          Validators.pattern(
            '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*.,?]).+$'
          ),
        ]),
      ],
      coupon_code: [null],
    });
    this.registerSchoolForm = formBuilder.group({
      email: [
        null,
        Validators.compose([Validators.required, Validators.email]),
      ],
      phone: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]*$'),
          Validators.minLength(10),
          Validators.maxLength(12),
        ]),
      ],
      school_name: [null, Validators.compose([Validators.required])],
      state_name: [null, Validators.compose([Validators.required])],
      city_name: [null, Validators.compose([Validators.required])],
      section_name: [null, Validators.compose([Validators.required])],
      zip_code: [null, Validators.compose([Validators.required])],
      password: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(20),
          Validators.pattern(
            '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*.,?]).+$'
          ),
        ]),
      ],
      password_confirmation: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(20),
          Validators.pattern(
            '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*.,?]).+$'
          ),
        ]),
      ],
    });


    this.registerAthleticDirectorForm = formBuilder.group({
      first_name: [null, Validators.compose([Validators.required])],
      last_name: [null, Validators.compose([Validators.required])],
      email: [
        null,
        Validators.compose([Validators.required, Validators.email]),
      ],
      phone: [
        null,
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]*$'),
          Validators.minLength(10),
          Validators.maxLength(12),
        ]),
      ],
      school_name: [null, Validators.compose([Validators.required])],

      state_name: [null, Validators.compose([Validators.required])],
      city_name: [null, Validators.compose([Validators.required])],
      section_name: [null, Validators.compose([Validators.required])],
      zip_code: [null, Validators.compose([Validators.required])],
      coupon_code:[null],
      password: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(20),
          Validators.pattern(
            '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*.,?]).+$'
          ),
        ]),
      ],
      password_confirmation: [
        null,
        Validators.compose([
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(20),
          Validators.pattern(
            '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[-+_!@#$%^&*.,?]).+$'
          ),
        ]),
      ],
    });

    this.registerForm.get('school_name')?.valueChanges.subscribe((val) => {
      this.schoolNameChanged();
    });
    this.registerSchoolForm
      .get('school_name')
      ?.valueChanges.subscribe((val) => {
        this.selectSchool();
      });

      this.registerAthleticDirectorForm.get('school_name')?.valueChanges.subscribe((val) => {
        this.schoolNameChangedAteletic();
      });




    // this.otpSent = true;
    // this.registerForm.patchValue({
    //   email: 'john.doe@yopmail.com'
    // })
  }

  async ngOnInit() {
    if (this.otp) {
      this.otpSent = true;
      this.emailToVerify = this.route.snapshot.queryParamMap.get('email') || '';
    } else {
      await this.fetchMaster();
      this.onQuaryParamChange();
    }
  }

  submitRegister(event: any) {
    this.registerForm.markAllAsTouched();
    setTimeout(() => {
      Global.scrollToQuery('.form-control.is-invalid');
    }, 100);
    if(this.registerForm.get('items')?.errors?.['duplicate'])
    {
      this.toastr.error("Duplicate Sport + Level combination is not allowed.");

    }
    if (this.registerForm.valid) {
      event.target.classList.add('btn-loading');
      event.target.disabled = true;

      this.authService
        .coachRegister({
          first_name: this.registerForm.value.first_name ?? null,
          last_name: this.registerForm.value.last_name ?? null,
          email: this.registerForm.value.email ?? null,
          phone: this.registerForm.value.phone ?? null,
          school_name: this.registerForm.value.school_name ?? null,
          state_name: this.registerForm.value.state_name ?? null,
          city_name: this.registerForm.value.city_name ?? null,
          section_name: this.registerForm.value.section_name ?? null,
          zip_code: this.registerForm.value.zip_code ?? null,
          division: this.registerForm.value.division ?? null,
          rating: this.registerForm.value.rating ?? null,
          league: this.registerForm.value.league ?? null,
          password: this.registerForm.value.password ?? null,
          sports_levels: this.registerForm.value.items ?? [],
          password_confirmation:
            this.registerForm.value.password_confirmation ?? null,
          coupon_code: this.registerForm.value.coupon_code ?? null,
        })
        .subscribe(
          async (res) => {
            const data = res.data;
            if (res.status == 'success') {
              if (data?.approve_by_admin == 'APPROVE') {

                this.router.navigate(['/login']);
                this.items.clear();
                this.items.push(this.newRequest());
                Global.resetForm(this.registerForm);
              } else {
                await this.fetchMaster({ loading: true });
                this.toastr.success(res.message);
                this.otpSent = true;
                this.emailToVerify = this.registerForm.value.email;
                // Global.resetForm(this.registerForm)
              }
            } else if (res.status == 'val_error') {
              this.toastr.error(Global.getValidationMessage(res.errors ?? []));
            } else {
              this.toastr.error(res.message);
            }

            event.target.classList.remove('btn-loading');
            event.target.disabled = false;
          },
          (err) => {
            event.target.classList.remove('btn-loading');
            event.target.disabled = false;
            this.toastr.error(Global.getServerErrorMessage(err));
          }
        );
    }
  }
  submitRegisterSchool(event: any) {
    this.registerSchoolForm.markAllAsTouched();
    console.log(this.registerSchoolForm.value);
    setTimeout(() => {
      Global.scrollToQuery('.form-control.is-invalid');
    }, 100);

    if (this.registerSchoolForm.valid) {
      event.target.classList.add('btn-loading');
      event.target.disabled = true;
      this.authService
        .schoolRegister({
          email: this.registerSchoolForm.value.email ?? null,
          phone: this.registerSchoolForm.value.phone ?? null,
          school_name: this.registerSchoolForm.value.school_name ?? null,
          state_name: this.registerSchoolForm.value.state_name ?? null,
          city_name: this.registerSchoolForm.value.city_name ?? null,
          section_name: this.registerSchoolForm.value.section_name ?? null,
          zip_code: this.registerSchoolForm.value.zip_code ?? null,
          password: this.registerSchoolForm.value.password ?? null,
          password_confirmation:
            this.registerSchoolForm.value.password_confirmation ?? null,
        })
        .subscribe(
          async (res) => {
            const data = res.data;
            if (res.status == 'success') {
              await this.fetchMaster({ loading: true });
              this.toastr.success(res.message);
              this.otpSent = true;
              this.emailToVerify = this.registerSchoolForm.value.email;
              // Global.resetForm(this.registerForm)
            } else if (res.status == 'val_error') {
              this.toastr.error(Global.getValidationMessage(res.errors ?? []));
            } else {
              this.toastr.error(res.message);
            }
            event.target.classList.remove('btn-loading');
            event.target.disabled = false;
          },
          (err) => {
            event.target.classList.remove('btn-loading');
            event.target.disabled = false;
            this.toastr.error(Global.getServerErrorMessage(err));
          }
        );
    }
  }
  submitRegisterAthleticDirector(event: any) {
    this.registerAthleticDirectorForm.markAllAsTouched();
    console.log(this.registerAthleticDirectorForm.value);
    setTimeout(() => {
      Global.scrollToQuery('.form-control.is-invalid');
    }, 100);

    if (this.registerAthleticDirectorForm.valid) {
      event.target.classList.add('btn-loading');
      event.target.disabled = true;
      this.authService
        .coachRegister({
          first_name: this.registerAthleticDirectorForm.value.first_name ?? null,
          last_name: this.registerAthleticDirectorForm.value.last_name ?? null,
          email: this.registerAthleticDirectorForm.value.email ?? null,
          phone: this.registerAthleticDirectorForm.value.phone ?? null,
          school_name: this.registerAthleticDirectorForm.value.school_name ?? null,
          state_name: this.registerAthleticDirectorForm.value.state_name ?? null,
          city_name: this.registerAthleticDirectorForm.value.city_name ?? null,
          section_name: this.registerAthleticDirectorForm.value.section_name ?? null,
          zip_code: this.registerAthleticDirectorForm.value.zip_code ?? null,
          password: this.registerAthleticDirectorForm.value.password ?? null,
          password_confirmation:this.registerAthleticDirectorForm.value.password_confirmation ?? null,
          coupon_code: this.registerForm.value.coupon_code ?? null,
          user_type:"athletic_director",


        })
        .subscribe(
          async (res) => {
            const data = res.data;
            if (res.status == 'success') {
              await this.fetchMaster({ loading: true });
              this.toastr.success(res.message);
              this.otpSent = true;
              this.emailToVerify = this.registerAthleticDirectorForm.value.email;
              // Global.resetForm(this.registerForm)
            } else if (res.status == 'val_error') {
              this.toastr.error(Global.getValidationMessage(res.errors ?? []));
            } else {
              this.toastr.error(res.message);
            }
            event.target.classList.remove('btn-loading');
            event.target.disabled = false;
          },
          (err) => {
            event.target.classList.remove('btn-loading');
            event.target.disabled = false;
            this.toastr.error(Global.getServerErrorMessage(err));
          }
        );
    }
  }
  otpVerificationAction(action: any) {
    if (action == true) {
      this.router.navigate(['/login']);
      this.toastr.success(
        ` ${
          this.queryParams == 'coach' ? 'Your ' : 'School '
        }   account has been created, please login (As ${
          this.queryParams == 'coach' ? 'Coach ' : 'School '
        } ) with given username and password, to complete the registration process. `
      );
      Global.resetForm(this.registerForm);
    } else {
      this.toastr.error(
        'Account Verification Failed. Please try again to continue'
      );
    }
  }

  newMasterValueEntered(type: any, label: any) {
    return label;
  }

  fetchMaster({ loading = <boolean>true } = {}) {
    return new Promise((resolve, reject) => {
      if (loading == true) this.spinner.show();

      this.coachService.fetchAllMaster().subscribe(
        (res) => {
          if (loading == true) this.spinner.hide();

          const data = res.data;
          if (res.status == 'success') {
            this.cityMaster = data?.city ?? [];
            this.divisionMaster = data?.division ?? [];
            this.drawMaster = data?.draw ?? [];
            this.levelMaster = data?.level ?? [];
            this.ratingMaster = data?.rating ?? [];
            this.schoolMaster = data?.school ?? [];
            this.sectionMaster = data?.section ?? [];
            this.sportMaster = data?.sport ?? [];
            this.stateMaster = data?.state ?? [];

            resolve(true);
          } else if (res.status == 'val_error') {
            this.toastr.error(Global.getValidationMessage(res.errors ?? []));
            reject(Global.getValidationMessage(res.errors ?? []));
          } else {
            this.toastr.error(res.message);
            reject(res.message);
          }
        },
        (err) => {
          if (loading == true) this.spinner.hide();

          this.toastr.error(Global.getServerErrorMessage(err));
          reject(Global.getServerErrorMessage(err));
        }
      );
    });
  }

  schoolNameChanged() {
    const school = this.registerForm.get('school_name')?.value;
    const exist = this.schoolMaster.find((obj: any) => {
      return obj._id == school;
    });

    if (exist) {
      this.spinner.show();
      this.coachService
        .getMasterSchoolDetails({
          _id: school,
        })
        .subscribe(
          (res) => {
            const data = res.data;
            if (res.status == 'success') {
              const school_details = data[0] ?? null;
              if (school_details) {
                this.registerForm.patchValue({
                  state_name:
                    school_details?.state_data?._id ??
                    this.registerForm.value.state_name,
                  city_name:
                    school_details?.city_data?._id ??
                    this.registerForm.value.city_name,
                  section_name:
                    school_details?.section_data?._id ??
                    this.registerForm.value.section_name,
                  zip_code:
                    school_details?.zip_code ??
                    this.registerForm.value.zip_code,
                });
              }
            } else {
              this.toastr.error(res.message);
            }

            this.spinner.hide();
          },
          (err) => {
            this.spinner.hide();
            this.toastr.error(Global.getServerErrorMessage(err));
          }
        );
    }
  }

  schoolNameChangedAteletic() {
    const school = this.registerAthleticDirectorForm.get('school_name')?.value;
    const exist = this.schoolMaster.find((obj: any) => {
      return obj._id == school;
    });

    if (exist) {
      this.spinner.show();
      this.coachService
        .getMasterSchoolDetails({
          _id: school,
        })
        .subscribe(
          (res) => {
            const data = res.data;
            if (res.status == 'success') {
              const school_details = data[0] ?? null;
              if (school_details) {
                this.registerAthleticDirectorForm.patchValue({
                  state_name:
                    school_details?.state_data?._id ??
                    this.registerAthleticDirectorForm.value.state_name,
                  city_name:
                    school_details?.city_data?._id ??
                    this.registerAthleticDirectorForm.value.city_name,
                  section_name:
                    school_details?.section_data?._id ??
                    this.registerAthleticDirectorForm.value.section_name,
                  zip_code:
                    school_details?.zip_code ??
                    this.registerAthleticDirectorForm.value.zip_code,
                });
              }
            } else {
              this.toastr.error(res.message);
            }

            this.spinner.hide();
          },
          (err) => {
            this.spinner.hide();
            this.toastr.error(Global.getServerErrorMessage(err));
          }
        );
    }
  }
  selectSchool() {
    const school = this.registerSchoolForm.get('school_name')?.value;
    const exist = this.schoolMaster.find((obj: any) => {
      return obj._id == school;
    });

    if (exist) {
      this.spinner.show();
      this.coachService
        .getMasterSchoolDetails({
          _id: school,
        })
        .subscribe(
          (res) => {
            const data = res.data;
            if (res.status == 'success') {
              const school_details = data[0] ?? null;
              if (school_details) {
                this.registerSchoolForm.patchValue({
                  state_name:
                    school_details?.state_data?._id ??
                    this.registerSchoolForm.value.state_name,
                  city_name:
                    school_details?.city_data?._id ??
                    this.registerSchoolForm.value.city_name,
                  section_name:
                    school_details?.section_data?._id ??
                    this.registerSchoolForm.value.section_name,
                  zip_code:
                    school_details?.zip_code ??
                    this.registerSchoolForm.value.zip_code,
                });
              }
            } else {
              this.toastr.error(res.message);
            }

            this.spinner.hide();
          },
          (err) => {
            this.spinner.hide();
            this.toastr.error(Global.getServerErrorMessage(err));
          }
        );
    }
  }
  onQuaryParamChange() {
    switch (this.queryParams) {
      case 'coach':
        this.changeSignupTab(0);
        break;
      case 'school':
        this.changeSignupTab(1);
        break;
      default:
        this.changeSignupTab(0);
        break;
    }
  }
  changeSignupTab(selectedTabIndex: number) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        tab: this.selectedTabIndex,
      },
    });
    this.selectedTabIndex = selectedTabIndex;
    switch (this.selectedTabIndex) {
      case 0:
        this.router.navigate(['signup'], { queryParams: { tab: 'coach' } });
        this.queryParams = 'coach';
        break;
      case 1:
        this.router.navigate(['signup'], { queryParams: { tab: 'school' } });
        this.queryParams = 'coach';
        break;
      default:
        break;
    }
  }
  get items(): FormArray {
      return this.registerForm.get('items') as FormArray;
    }

    newRequest(): FormGroup {
      return this.formBuilder.group({
        sport: [null, Validators.required],
        level: [null, Validators.required],

      });
    }

    addRequest() {
      console.log(this.newRequest());
      this.items.push(this.newRequest());
    }

    removeRequest(index: number) {
      this.items.removeAt(index);
    }
      duplicateSportLevelValidator(): ValidatorFn {
        return (formArray: AbstractControl): ValidationErrors | null => {
          const controls = (formArray as FormArray).controls;

          const seen = new Set<string>();
          for (const group of controls) {
            const sport = group.get('sport')?.value;
            const level = group.get('level')?.value;

            if (sport && level) {
              const key = `${sport}-${level}`;
              if (seen.has(key)) {
                return { duplicate: true }; // ❌ duplicate found
              }
              seen.add(key);
            }
          }

          return null; // ✅ valid
        };
      }
      removeItem(i:number)
      {
        this.items.removeAt(i);
      }
}
